/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Author_WundoInputs */



/**
* | output |
* | --- |
* | "Wundo" |
*
* @param {Chat_Author_WundoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_author_wundo = /** @type {((inputs?: Chat_Author_WundoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Author_WundoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo")
	return /** @type {LocalizedString} */ ("Wundo")
});